import React from 'react';
import { CircularProgress, Stack } from '@mui/material';
import { fullSize } from '../../../Constants';
import DocumentDetailsViewContent from './DocumentDetailsViewContent';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../redux/store';
import DocumentDetailsError from './DocumentDetailsError';

/**
 * Component that checks if data is loaded without errors.
 */
export default ({ isDialog = false }: IDocumentDetailsContentProps) => {
    /** Allow component to change the URL. */
    const { replicaId } = useParams();

    /** Access relevant state variables from the redux store. */
    const { loading: docTypesLoading, error: docTypesError } = useSelector(
        (store: IAppReduxStore) => store.projectDocTypes,
    );
    const { loading: docStatusLoading, error: docStatusError } = useSelector(
        (store: IAppReduxStore) => store.projectDocStatus,
    );
    const {
        data: documentDetailsData,
        loading: documentDetailsLoading,
        error: documentDetailsError,
        docTypeKeyForTemplateCreation,
    } = useSelector((store: IAppReduxStore) => store.projectDocumentDetails);

    if (docTypeKeyForTemplateCreation) {
        return <DocumentDetailsViewContent replicaId={replicaId} isDialog={isDialog} />;
    }

    if (docTypesLoading || documentDetailsLoading || docStatusLoading) {
        return (
            <Stack
                sx={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    ...fullSize,
                }}
            >
                <CircularProgress />
            </Stack>
        );
    }

    if (docTypesError || documentDetailsError || docStatusError) {
        return <DocumentDetailsError />;
    }

    if (documentDetailsData.IdDocIndex) {
        return <DocumentDetailsViewContent replicaId={replicaId} isDialog={isDialog} />;
    }
    return <></>;
};

/**
 * Interface that describes the props for a DocumentDetailsContent component.
 */
export interface IDocumentDetailsContentProps {
    /** (OPTION) Defines if the content Component is Dialog or Browser tab. */
    isDialog?: boolean;
}
